import { isServerSide } from '@/utils/ssr';
import axios, { AxiosError } from 'axios';

const baseURL = isServerSide()
  ? `${process.env.SITE_URL}${process.env.NEXT_PUBLIC_API_URL}`
  : process.env.NEXT_PUBLIC_API_URL;

const api = axios.create({
  baseURL,
  withCredentials: true,
});

if (isServerSide()) {
  api.interceptors.request.use(async (config) => {
    const { cookies } = await import('next/headers');

    const cookiesString = cookies()
      .getAll()
      .map((item) => `${item.name}=${item.value}`)
      .join('; ');

    config.headers.set('cookie', cookiesString);

    return config;
  });
} else {
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      const axiosError = error as AxiosError;

      if (axiosError?.response?.status === 401) {
        window.location.href = '/logout';
        return;
      }

      return Promise.reject(error);
    }
  );
}

export default api;
